import React,{useEffect, useContext, useState} from 'react';
import logo from '../../images/logo/VJLOGO.png';
import Card from 'react-bootstrap/Card';
import { ProductContext } from '../../ProductProvider';
import {Helmet} from 'react-helmet-async';

export default function LandingPage() {

  const { validateLogin, loggedUser} = useContext(ProductContext);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    if(!loggedUser.isAuthenticated){
      validateLogin();
    }
    setLoaded(true);
    //console.log("logged user : ", loggedUser);
  }, [loggedUser])

  return (
    <div className="App">
    <Helmet>
      <title>Faculty Portal - Vidyajyoti College of Theology - Delhi || Institute of Religious Studies</title>
      <meta name="description" content="Faculty Portal - Vidyajyoti College of Theology - Delhi || Institute of Religious Studies" />
      <meta name="keywords" content="Faculty Portal - Vidyajyoti College of Theology - Delhi || Institute of Religious Studies" /> 
    </Helmet>

        <Card>
            <Card.Body>
                <h3 style={{fontFamily:'sans-serif'}}>WELCOME <br/>Vidyajyoti College of Theology</h3>
                <img className='img-responsive' src={logo} alt='logo' width="400px" />
                <h1>Faculty Portal</h1>
            </Card.Body>
        </Card>
    </div>
  )
}
